let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("h2MrD"), load("bYT2S"), load("aRh7g")]).then(() => parcelRequire('bF4NR'));